import {
    Divider,
    Paper,
    Typography
} from '@material-ui/core';
import { createStyles, WithStyles, withStyles } from '@material-ui/core/styles';
import { User as UserComponent } from '../user';
import { Theme } from '@material-ui/core/styles';
import * as React from 'react';
import { AccountFull } from '../../models/account';
import { Role } from '../../models/role';
import { UserFull } from '../../models/user';
import { SimpleListItem } from '../../shared/components/simple-list';
import { EmailSearch } from '../email-search';
import { CCSpinner } from '../../shared/components/cc-spinner';
import { SimpleListPagination } from '../../shared/components/simple-list-pagination';

const styles = (theme: Theme) =>
    createStyles({
        [theme.breakpoints.down('lg')]: {
            divider: {
                margin: '1em 0 !important'
            },
            noResultsContainer: {
                textAlign: 'center !important'
            },
            fullWidthInput: {
                width: '100% !important'
            },
            simpleFormContainer: {
                width: '25em !important'
            }
        },
        divider: {
            margin: '2em 0'
        },
        root: {
            display: 'flex',
            flexWrap: 'wrap'
        },
        container: {
            display: 'flex',
            flexDirection: 'column'
        },
        heading: {
            fontWeight: 700,
            marginBottom: '0.5em',
            marginTop: '1em'
        },
        simpleList: {
            overflow: 'auto',
            height: '100%',
            minWidth: '20em'
        },
        simpleFormContainer: {
            marginLeft: '2em',
            width: '30em'
        },
        noResultsContainer: {
            alignItems: 'center',
            justifyContent: 'center',
            flex: 1,
            '& > *': {
                color: 'rgba(0,0,0,0.2)'
            }
        },
        childContainer: {
            display: 'flex',
            flexDirection: 'column',
            marginBottom: '1.5em',
            padding: '0.5em'
        },
        fullWidthInput: {
            width: '100% !important'
        },
        userAvatar: {
            minWidth: '20em !important',
        },
        userSearchErrorMessage: {
            textAlign: 'center'
        }
    });

interface Props extends WithStyles<typeof styles> {
    className?: string;
    selectedAccount: AccountFull;
    searchedUser: UserFull | null;
    searchedUserRoles: Role[];
    userIsLoading: boolean;
    isUserSearchWarning: boolean;
    userSearchWarning: string;
    onUserSearch?: (email: string) => void;
    onRoleRemove?: (roleId: string) => void;
    onUserClear?: () => void;
}

interface States {
    userEmailSearch: string
}

class UserSchedulingSearch extends React.Component<Props, States> {
    state: States = {
        userEmailSearch: '',
    };

    onSearchClicked = (email: string) => {
        const { selectedAccount, onUserSearch } = this.props;

        if (!email || email === '' || !selectedAccount || !onUserSearch) {
            return;
        }

        onUserSearch(email);
    };

    onDeleteItemClicked = (listItem: SimpleListItem) => {
        const { onRoleRemove } = this.props;
        if (onRoleRemove) {
            onRoleRemove(listItem.id);
        }
    };

    onClearButtonClicked = () => {
        const { searchedUser, onUserClear } = this.props;
        
        if (!searchedUser || !onUserClear) {
            return;
        }

        onUserClear();
    };

    public render() {
        const { className, classes } = this.props;

        const {
            userIsLoading,
            searchedUser,
            searchedUserRoles,
            isUserSearchWarning,
            userSearchWarning
        } = this.props;
        const { userEmailSearch } = this.state;

        const schedulingRoles = searchedUserRoles ? searchedUserRoles.map((role: Role) => {
            return new SimpleListItem(`${role.id}`, role.name, `Role id: ${role.id}`);
        }) : [];

        return (
            <div
                className={`${classes.root} ${className}`}
                data-testid="user-scheduling-finder"
            >
                <div
                    className={`${classes.container} ${classes.simpleFormContainer}`}
                >
                    <Typography
                        variant="h6"
                        className={`${classes.heading}`}
                        >
                        User Scheduling Roles
                    </Typography>
                        <Paper>
                            <EmailSearch
                                classes={{textField: classes.fullWidthInput}}
                                email={userEmailSearch}
                                canClear={searchedUser ? true : false}
                                onSearchClick={this.onSearchClicked}
                                onClearClick={this.onClearButtonClicked}
                            />
                            <Divider className={classes.divider} />
                            <CCSpinner loading={userIsLoading} size={100}>
                                {searchedUser && !isUserSearchWarning && (
                                    <React.Fragment>
                                        <div className={classes.childContainer}>
                                            <UserComponent
                                                classes={{container: classes.userAvatar}}
                                                className={classes.userComponent}
                                                email={searchedUser.email}
                                                fullName={
                                                    searchedUser.firstname &&
                                                    searchedUser.firstname.length > 0 &&
                                                    searchedUser.lastname &&
                                                    searchedUser.lastname.length > 0
                                                        ? `${searchedUser.firstname} ${searchedUser.lastname}`
                                                        : ''
                                                }
                                                userName={
                                                    searchedUser.username
                                                        ? searchedUser.username
                                                        : ''
                                                }
                                                userCreationDate={
                                                    new Date(searchedUser.timestamp)
                                                }
                                                userId={searchedUser._id}
                                                verified={true}
                                            />
                                        </div>
                                        <div className={classes.childContainer} data-testid="user-teams">
                                            <Typography
                                                className={classes.header}
                                                variant='h6'
                                            >
                                                User's Roles
                                            </Typography>
                                            <SimpleListPagination
                                                className={classes.simpleList}
                                                items={schedulingRoles}
                                                noItemsLabel="No roles available"
                                                canDeleteListItem={true}
                                                onDeleteItemClick={this.onDeleteItemClicked}
                                                rowsPerPage={10}
                                            />
                                        </div>
                                    </React.Fragment>
                                )}
                                {isUserSearchWarning && (
                                    <div
                                        className={`${classes.container} ${classes.noResultsContainer}`}
                                    >
                                        <Typography variant="h4" className={classes.userSearchErrorMessage}>
                                            {userSearchWarning}
                                        </Typography>
                                    </div>
                                )}
                            </CCSpinner>
                        </Paper>
                </div>
            </div>
        );
    }
}

const MUIComponent = withStyles(styles)(UserSchedulingSearch);
export { MUIComponent as UserSchedulingSearch };
